import { Text } from '../ExpandableLink/ExpandableLink.style';
import { media } from '../../styles';
import styled from 'styled-components';

export const RowTitle = styled.div`
  background-color: ${({ theme }) => theme.color.neutral.default};
  border: ${({ theme }) => `1px solid ${theme.typography.color.tertiary}`};
  display: flex;
  flex-direction: row;
  font-size: ${({ theme }) => theme.typography.size.small};
  font-weight: bold;
  padding: ${({ theme }) => `${theme.spacing.base.xs} 0 ${theme.spacing.base.xs} ${theme.spacing.base.sm}`};
`;

export const RowSubtitle = styled.div`
  background-color: ${({ theme }) => theme.color.neutral.default};
  display: flex;
  flex-direction: row;
  font-size: ${({ theme }) => theme.typography.size.small};
  color: ${({ theme }) => `${theme.typography.color.secondary}`};
  padding: ${({ theme }) => `${theme.spacing.base.xs} 0 ${theme.spacing.base.xs} ${theme.spacing.base.sm}`};
  border-left: ${({ theme }) => `1px solid ${theme.typography.color.tertiary}`};
  border-right: ${({ theme }) => `1px solid ${theme.typography.color.tertiary}`};
`;

export const RowContent = styled.div`
  border: ${({ theme }) => `1px solid ${theme.typography.color.tertiary}`};
  border-top: none;
  display: flex;
  flex-direction: row;
  flex: 1 1 100%;
  font-size: ${({ theme }) => theme.typography.size.small};
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacing.base.xs} ${theme.spacing.base.sm}`};

  ${media.mobilePortrait} {
    flex-wrap: wrap;
  }
`;

type TextProps = {
  withTopMargin?: boolean;
};

export const TextSmall = styled(Text)<TextProps>`
  font-size: ${({ theme }) => theme.typography.size.small};
  margin-top: ${({ withTopMargin, theme }) => (withTopMargin ? theme.spacing.base.xs : 'initial')};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 66%;

  ${media.mobilePortrait} {
    flex-basis: 100%;
    width: initial;
  }
`;
